import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { sendEmailVerification } from 'firebase/auth';
import { auth } from '@/lib/firebase';
import { signOutUser } from '@/lib/signOut';
import { useAuth } from '@/stores/auth';
import { AuthLayout } from './AuthLayout';
import { Button } from '@/components/ui/Button';
import { toast } from '@/components/ui/Toast';

export default function VerifyEmailPage() {
  const { firebaseUser, initialised } = useAuth();
  const [resending, setResending] = useState(false);

  if (!initialised) return null;
  if (!firebaseUser) return <Navigate to="/auth/sign-in" replace />;
  if (firebaseUser.emailVerified) return <Navigate to="/feed" replace />;

  const onResend = async () => {
    setResending(true);
    try {
      await sendEmailVerification(firebaseUser);
      toast.success('Verification email sent.');
    } catch (err) {
      toast.error(err instanceof Error ? err.message : String(err));
    } finally {
      setResending(false);
    }
  };

  const onCheck = async () => {
    await firebaseUser.reload();
    if (auth.currentUser?.emailVerified) {
      toast.success('Verified!');
      window.location.assign('/feed');
    } else {
      toast.info('Not verified yet. Check your inbox.');
    }
  };

  return (
    <AuthLayout
      title="Verify your email"
      subtitle={`We sent a link to ${firebaseUser.email}. Click it, then come back here.`}
    >
      <Button onClick={onCheck} className="w-full">
        I verified — continue
      </Button>
      <Button onClick={onResend} variant="secondary" className="w-full" loading={resending}>
        Resend verification email
      </Button>
      <button
        onClick={() => void signOutUser()}
        className="text-xs text-makhe-muted/80 hover:text-makhe-ink"
      >
        Sign out and use a different email
      </button>
    </AuthLayout>
  );
}
